export const TRACKING_STATUS = {
  PREPARING: 'preparing',
  ON_DELIVERY: 'on_delivery',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
};

export const FILTER_TABS = [
  { id: 'all', label: 'All Orders' },
  { id: TRACKING_STATUS.PREPARING, label: 'Preparing' },
  { id: TRACKING_STATUS.ON_DELIVERY, label: 'On Delivery' },
  { id: TRACKING_STATUS.DELIVERED, label: 'Delivered' },
];

export const STATUS_BADGE = {
  [TRACKING_STATUS.PREPARING]: { label: 'Preparing', className: 'otd-badge--preparing' },
  [TRACKING_STATUS.ON_DELIVERY]: { label: 'On Delivery', className: 'otd-badge--delivery' },
  [TRACKING_STATUS.DELIVERED]: { label: 'Delivered', className: 'otd-badge--delivered' },
  [TRACKING_STATUS.CANCELLED]: { label: 'Cancelled', className: 'otd-badge--cancelled' },
};

export const MAP_STYLE_OPTIONS = [
  { id: 'roadmap', label: 'Map' },
  { id: 'satellite', label: 'Satellite' },
  { id: 'layers', label: 'Layers' },
];

export const TILE_URLS = {
  roadmap: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
  satellite:
    'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
  layers: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
};

export const DEFAULT_MAP_CENTER = [41.8781, -87.6298];

export const MAP_MARKER_VIEW = {
  RESTAURANT: 'restaurant',
  CUSTOMER: 'customer',
  BOTH: 'both',
};

export const MAP_MARKER_VIEW_TABS = [
  { id: MAP_MARKER_VIEW.RESTAURANT, label: 'Restaurant' },
  { id: MAP_MARKER_VIEW.CUSTOMER, label: 'Customer' },
  { id: MAP_MARKER_VIEW.BOTH, label: 'Both' },
];

/** Zip boundaries from localStorage cache (same source as ZipcodeMap). */
export const ZIP_BOUNDARY_STYLE = {
  color: '#DC2626',
  weight: 1.5,
  fillColor: '#DC2626',
  fillOpacity: 0.12,
  opacity: 0.85,
};
